import { formatPhoneNumber, logPhoneInfo } from './phoneUtils';

/**
 * Decodes a JWT token and returns the payload
 * @param {string} token - The JWT token to decode
 * @returns {Object|null} The decoded payload or null if invalid
 */
export const decodeToken = (token) => {
  try {
    if (!token) return null;
    
    // Split the token and get the payload (middle part)
    const parts = token.split('.');
    if (parts.length !== 3) return null;
    
    // Decode the base64 payload
    const base64Url = parts[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    
    // Handle padding
    const padding = '='.repeat((4 - base64.length % 4) % 4);
    const base64Padded = base64 + padding;
    
    // Decode the base64 string
    const jsonPayload = atob(base64Padded);
    
    // Parse the JSON payload
    const payload = JSON.parse(jsonPayload);
    
    return payload;
  } catch (error) {
    console.error('Error decoding JWT token:', error);
    return null;
  }
};

/**
 * Checks if a token is expired
 * @param {Object} payload - The decoded token payload
 * @returns {boolean} True if token is expired, false otherwise
 */
export const isTokenExpired = (payload) => {
  if (!payload || !payload.exp) return true;
  
  const currentTime = Math.floor(Date.now() / 1000);
  return payload.exp < currentTime;
};

/**
 * Gets the current authenticated user data from local storage tokens
 * @returns {Object|null} User data or null if not authenticated
 */
export const getCurrentUser = () => {
  try {
    // Try to get token from either token or dToken (for different user roles)
    const token = localStorage.getItem('token') || localStorage.getItem('dToken');
    if (!token) return null;
    
    // Decode the token
    const userData = decodeToken(token);
    
    // Check if token is expired
    if (isTokenExpired(userData)) {
      console.warn("Token is expired");
      return null;
    }
    
    return userData;
  } catch (error) {
    console.error('Error getting current user:', error);
    return null;
  }
};

/**
 * Logs out the current user by removing tokens
 */
export const logoutUser = () => {
  localStorage.removeItem('token');
  localStorage.removeItem('dToken');
  localStorage.removeItem('authToken');
  
  // Force reload to clear any in-memory state
  window.location.href = '/login';
};
